const formatWeight = (weightString: string) => {
  if (!weightString) {
    return ''
  }

  const numericWeight = parseFloat(weightString.replace(/[^\d.]/g, ''))

  if (!numericWeight) {
    return ''
  }

  if (numericWeight >= 2000) {
    const weightInTonnes = numericWeight / 1000
    return `${weightInTonnes.toFixed(2).replace(/\.?0+$/, '')} t`
  }

  return `${numericWeight} kg`
}

export default formatWeight
